"use client";

import { createContext, useContext } from "react";

/**
 * Wo die Kopfaktionen einer App (`topNavChildren`) gerade stehen.
 *
 * `"kopfzeile"` — rechts in einer Kopfzeile (V1-`TopNav`, V2-Handykopf): ein
 * Popup oeffnet nach LINKS, sonst laeuft es aus dem rechten Rand.
 * `"leiste"` — im Kopf der Seitenleiste (V2 am Schirm), also am linken Rand:
 * ein Popup muss nach RECHTS oeffnen, sonst schneidet der Schirmrand die
 * 320 px breite Glocke um gut 100 px ab.
 */
export type KopfaktionenOrt = "kopfzeile" | "leiste";

const Ort = createContext<KopfaktionenOrt>("kopfzeile");

export const KopfaktionenOrtProvider = Ort.Provider;

export function useKopfaktionenOrt(): KopfaktionenOrt {
  return useContext(Ort);
}
